import {
  FDBodyText, FDDisplayText, FDHeadlineText, FDTitleText,
} from '@facet-wealth/design';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { ReferralPageInfoBoxes } from 'Views/Page/Content/Templates/ReferralPage/Components/ReferralPageInfoBoxesV1';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDDisplayText,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDHeadlineText,
  }, overrideReadOnly)
  .nameOverride('howToTitle', {
    _component: () => FDHeadlineText,
  }, overrideReadOnly)
  .nameOverride(['messageTitle', 'linkTitle'], {
    _component: () => FDTitleText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly)
  .nameOverride('howToInfo', {
    _component: () => ReferralPageInfoBoxes,
  }, overrideReadOnly)
  .nameOverride('referralMessage', {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .nameOverride('referralLink', {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .nameOverride('attestation', {
    _component: () => Richtext,
    _customProps: {
      color: 'textDisabled',
      Component: FDBodyText,
    },
  }, overrideReadOnly)
  .done();
